const PREFIX = "Shared/DocumentTemplate/";

export const RECEIVE_DOCUMENT_TEMPLATES = `${PREFIX}RECEIVE_DOCUMENT_TEMPLATES`;
